//
// BooleanFieldOptions
//
// Field options for type 'boolean'

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../stores'

import { HView, Spacer } from '../../../../appview'
import { BooleanInput } from '../../../../components'
import { LabeledField } from '../../../components'

export const BooleanFieldOptions = observer(function BooleanFieldOptions({
    field,
    selectModified,
    worksheet,
    onAction,
    setSelected,
    renderkeyprefix,
}) {
    const { app } = useStore()

    if (!field) return null

    const initial = field.initial.get(worksheet.language)

    const onSetValue = newValue => {
        field.setProperty('initial', newValue, worksheet.language)
        field.commitIfModified().then(result => selectModified(result))
    }

    return (
        <>
            <LabeledField label={app.text('initial value')}>
                <HView>
                    <BooleanInput value={initial} onSetValue={onSetValue} />
                    <Spacer grow />
                </HView>
            </LabeledField>
        </>
    )
})
